import * as React from "react";
import { Link } from "@grandvisionhq/common";
import "../../../../events/events/event-properties-provider.js";
import { useDispatchTrackClickEvent } from "../../../../events/events/use-track-click-event.js";
const TealiumLink = ({ tealiumEvent, ...props }) => {
  const { onClick, ...rest } = props;
  const dispatchTrackClickEvent = useDispatchTrackClickEvent();
  const handleClick = (event) => {
    if (tealiumEvent) {
      try {
        dispatchTrackClickEvent({
          ...tealiumEvent
        });
      } catch (error) {
        console.error("Tealium dispatch error:", error);
      }
    }
    if (onClick) {
      onClick(event);
    }
  };
  return /* @__PURE__ */ React.createElement(Link, { ...rest, onClick: handleClick });
};
export {
  TealiumLink
};
//# sourceMappingURL=TealiumLink.js.map
